Monitoring.Views ||= {}

class Monitoring.Views.SocialContentConditionEditView extends Backbone.View
  template: JST["backbone/templates/monitoring/rules/social_content_condition_edit"]

  events:
    'change #condition-topics': 'onChangeTopics'
    'change #no-other-tags': 'onChangeNoOtherTags'
    'change #condition-subtypes': 'onChangeSubtypes'
    'change #condition-sentiments': 'onChangeSentiments'
    'change input[name=condition-ownership]': 'onChangeOwnership'
    'change input[name=moderation-status]': 'onChangeModerationStatus'
    'change #condition-authors': 'onChangeAuthors'
    'change #condition-excluded-authors': 'onChangeExcludedAuthors'
    'change #condition-locations': 'onChangeLocations'
    'change #condition-mentions': 'onChangeMentions'
    'change #condition-minimum-followers': 'onChangeMinimumFollowers'
    'change #condition-news-sources': 'onChangeNewsSources'
    'click #edit-condition-keywords': 'onClickEditKeywords'

  initialize: (@options = {}) ->
    @socialContentCondition = @options.socialContentCondition
    @availableTopics = @options.availableTopics
    @availableTags = @options.availableTags
    @availableLabels = @options.availableGroups
    @availableSubtypes = @options.availableSubtypes
    @editView = @options.editView
    @noOtherTags = !!@options.noOtherTags
    @newsFilterAllowed = !!@options.newsFilterAllowed
    @showLocation = if @options.showLocation?
      @options.showLocation
    else
      true
    @availableSentiments = _.map(['negative', 'neutral', 'positive', 'missing'], (s) ->
      {
        name: I18n.t('monitoring.rules.sentiments.' + s)
        code: s
      }
    )

    @_initializeIntelligentTagsFilterView()
    @_initializeIntelligentLabelsFilterView()

  render: =>
    @$el.html(@template(@))
    @_renderLabelsFilter()
    @_renderTagsFilter()
    @renderKeywordsEditView()
    @initializeChosen()
    @

  _initializeIntelligentTagsFilterView: ->
    @intelligentTagsFilterView = new Customer.ResponseTemplateTagsFilterView
      filter: @socialContentCondition.intelligent_filter.intelligent_tags
      possibleTags: @availableTags
      hiddenTags: []
      useCustomValues: true

  _initializeIntelligentLabelsFilterView: ->
    @intelligentLabelsFilterView = new Customer.ResponseTemplateGroupsFilterView
      filter: @socialContentCondition.intelligent_filter
      groups: @availableLabels
      useCustomValues: true

  _renderTagsFilter: ->
    @$('.tags-filter-container').html(@intelligentTagsFilterView.render().el)

  _renderLabelsFilter: ->
    @$('.labels-filter-container').html(@intelligentLabelsFilterView.render().el)

  getCondition: ->
    @socialContentCondition['intelligent_filter'] =
      intelligent_groups: @intelligentLabelsFilterView.getIntelligentGroups()
      intelligent_tags: @intelligentTagsFilterView.getIntelligentTags()
    @socialContentCondition

  initializeChosen: ->
    @$el.find('.chosen-select').chosen({
      width: '395px',
      enable_split_word_search: true,
      search_contains: true
    });

  renderKeywordsEditView: ->
    @keywords = new Monitoring.Views.KeywordsCondition(@getCondition().keywords)
    @keywordsEditView = new Monitoring.Views.SocialContents.Filters.KeywordsFilterView(
      searchQuery: @keywords,
      forRule: true,
      validations: @keywordValidations())
    @editView.append(@keywordsEditView.render().el)
    @editView.find('.filter.collapsed').remove()
    @listenTo(@keywordsEditView, 'changed:keywords', @onChangeKeywords)
    @editView.find('#edit_keywords_modal').on('hidden.bs.modal', () =>
      @trigger('reviewQueue:closeEditModal')
    )

  onChangeTopics: (evt) ->
    @onChangeMultiselectProperty('topics', true)

  removeChosenOption: (propertyName, value) =>
    $("#condition-#{propertyName} option[value=#{value}]").prop('selected', false).trigger('chosen:updated')

  onChangeSubtypes: (evt) ->
    @onChangeMultiselectProperty('subtypes')

  onChangeOwnership: (evt) ->
    selectedOption = @$el.find("input[name=condition-ownership]:checked")
    @socialContentCondition.ownership = selectedOption.attr('value')

  onChangeModerationStatus: (evt) ->
    selectedOptions = @$el.find("input[name=moderation-status]:checked")
    @socialContentCondition.moderation_statuses = _.map(selectedOptions, (selected) -> selected.value)

  onChangeNoOtherTags: (evt) ->
    checked = @$el.find("#no-other-tags").prop('checked') || false
    @socialContentCondition.no_other_tags = checked

  onChangeAuthors: (evt) ->
    @onChangeTextProperty('authors')

  onChangeExcludedAuthors: (evt) ->
    @onChangeTextProperty('excluded_authors')

  onChangeLocations: (evt) ->
    @onChangeTextProperty('locations')

  onChangeMentions: (evt) ->
    @onChangeTextProperty('mentions')

  onChangeMinimumFollowers: (evt) ->
    enteredProperty = @$el.find("#condition-minimum-followers").val()
    @socialContentCondition.min_followers = enteredProperty

  onChangeNewsSources: (evt) ->
    @onChangeTextProperty('news_sources')

  onChangeSentiments: (evt) ->
    @onChangeMultiselectProperty('sentiments')

  onChangeTextProperty: (propertyName) ->
    enteredProperty = @$el.find("#condition-#{propertyName.replace('_', '-')}").val().trim()
    asArray = _.map(enteredProperty.split(','), (r) -> r.trim())
    @socialContentCondition[propertyName] = asArray

  onChangeMultiselectProperty: (propertyName, isInteger = false) ->
    selectedOptions = @$el.find("#condition-#{propertyName.replace('_', '-')} option:selected")
    enteredProperties = _.map(selectedOptions, (opt) -> if isInteger then parseInt(opt.value) else opt.value)
    @socialContentCondition[propertyName] = enteredProperties

  onClickEditKeywords: ->
    @editView.find('#edit_keywords_modal').modal()
    @trigger('reviewQueue:openEditModal')

  onChangeKeywords: (primary, secondary, excluded, plogic, slogic, elogic) =>
    @trigger('reviewQueue:closeEditModal')
    @keywords.set('primary_keywords', primary || [])
    @keywords.set('secondary_keywords', secondary || [])
    @keywords.set('excluded_keywords', excluded || [])
    @keywords.set('primary_keywords_logic', plogic)
    @keywords.set('secondary_keywords_logic', slogic)
    @keywords.set('excluded_keywords_logic', elogic)

  keywordValidations: =>
    [
        condition: (keyword) ->
          isValid = true
          try new RegExp(keyword)
          catch e then isValid = false
          isValid
        message: (keyword) -> "#{keyword} #{I18n.t('monitoring.rules.validations.invalid_keyword')}"
    ]

  allMandatoryFieldsAreFilled: =>
    true
